export default __webpack_public_path__ + "static/study-image01-cd14220f18f1c6465bf54858a2ace67d.jpg";